import React, { Component } from 'react';
import { Guardian } from '@xaamin/guardian';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CartaPorteMercanciaForm from './CartaPorteMercanciaForm';
import CartaPorteMercanciasUploadFile from './CartaPorteMercanciasUploadFile';
import CartaPorteMercanciaPedimentosManager from './CartaPorteMercanciaPedimentosManager';
import CartaPorteMercanciaDetalleMercanciaForm from './CartaPorteMercanciaDetalleMercanciaForm';
import CartaPorteMercanciaCantidadTransportaManager from './CartaPorteMercanciaCantidadTransportaManager';
import CartaPorteMercanciaGuiasIdentificacionManager from './CartaPorteMercanciaGuiasIdentificacionManager';
import CartaPorteMercanciaDocumentacionAduaneraManager from './CartaPorteMercanciaDocumentacionAduaneraManager';

class CartaPorteMercancias extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      isUploadFile: false,
      isValidDetalleMercancia: false,
      isTouchedDetalleMercancia: false,
    };
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        isValid: true,
        pedimentos: !!data.Pedimentos,
        cantidad_transporta: !!data.CantidadTransporta,
        guias_identificacion: !!data.GuiasIdentificacion,
        documentacion_aduanera: !!data.DocumentacionAduanera,
      });
    }
  }

  handleOnChange = (value, isValid = false) => {
    const data = {
      ...this.state.data,
      ...value,
    };

    this.setState({
      data,
      isValid: isValid,
    });
  };

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.handleOnSuggestionSelect(undefined);

    this.setState({
      data: {},
      isValid: false,
      pedimentos: false,
      cantidad_transporta: false,
      guias_identificacion: false,
      documentacion_aduanera: false,
    });
  };

  handleOnAdditionalCheckboxChange = (event) => {
    const { name, checked } = event.target;

    this.setState({
      [name]: checked,
    });
  };

  handleOnAdditionalChange = (additional) => {
    this.setState({
      data: {
        ...this.state.data,
        ...additional,
      },
    });
  };

  handleOnSuggestionSelect = (name) => (item) => {
    const value = item ? item.clave : '';

    let values = {
      [name]: value,
    };

    this.handleOnChange(values);
  };

  handleOnDetalleMercanciaDataChange = (event) => {
    const data = {
      ...this.state.data.DetalleMercancia,
      ...event.data,
    };

    this.setState({
      data: {
        ...this.state.data,
        DetalleMercancia: data,
      },
      isValidDetalleMercancia: event.isValid,
      isTouchedDetalleMercancia: event.isTouched,
    });
  };

  handleOnShowUploadFile = () => {
    this.setState({
      isUploadFile: true,
    });
  };

  handleOnCloseUploadFile = () => {
    this.setState({
      isUploadFile: false,
    });
  };

  handleOnUploadFile = (values) => {
    this.props.onUploadFile(values);
  };

  render() {
    const { version } = this.props;
    const {
      data = {},
      isValid,
      pedimentos,
      isUploadFile,
      cantidad_transporta,
      guias_identificacion,
      documentacion_aduanera,
      isValidDetalleMercancia,
      isTouchedDetalleMercancia,
    } = this.state;

    return (
      <>
        <CartaPorteMercanciaForm
          data={data}
          version={version}
          onFormDataChange={this.handleOnChange}
        />

        {isUploadFile && (
          <CartaPorteMercanciasUploadFile
            data={data}
            show={isUploadFile}
            onAdd={this.handleOnUploadFile}
            onClose={this.handleOnCloseUploadFile}
          />
        )}

        <Row>
          <Col>
            <CartaPorteMercanciaDetalleMercanciaForm
              data={data.DetalleMercancia || {}}
              onFormDataChange={this.handleOnDetalleMercanciaDataChange}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Group controlId="documentacion_aduanera">
              <Form.Check
                type="checkbox"
                name="documentacion_aduanera"
                label="Incluir Documentación Aduanera"
                checked={documentacion_aduanera || false}
                onChange={this.handleOnAdditionalCheckboxChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {documentacion_aduanera && (
          <CartaPorteMercanciaDocumentacionAduaneraManager
            data={data}
            onChange={this.handleOnAdditionalChange}
          />
        )}

        <Row>
          <Col>
            <Form.Group controlId="pedimentos">
              <Form.Check
                type="checkbox"
                name="pedimentos"
                label="Incluir Pedimentos"
                checked={pedimentos || false}
                onChange={this.handleOnAdditionalCheckboxChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {pedimentos && (
          <CartaPorteMercanciaPedimentosManager
            data={data}
            onChange={this.handleOnAdditionalChange}
          />
        )}

        <Row>
          <Col>
            <Form.Group controlId="guias_identificacion">
              <Form.Check
                type="checkbox"
                name="guias_identificacion"
                label="Incluir Guias"
                checked={guias_identificacion || false}
                onChange={this.handleOnAdditionalCheckboxChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {guias_identificacion && (
          <CartaPorteMercanciaGuiasIdentificacionManager
            data={data}
            onChange={this.handleOnAdditionalChange}
          />
        )}

        <Row>
          <Col>
            <Form.Group controlId="cantidad_transporta">
              <Form.Check
                type="checkbox"
                name="cantidad_transporta"
                label="Incluir Cantidad Transporta"
                checked={cantidad_transporta || false}
                onChange={this.handleOnAdditionalCheckboxChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {cantidad_transporta && (
          <CartaPorteMercanciaCantidadTransportaManager
            data={data}
            onChange={this.handleOnAdditionalChange}
          />
        )}

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar varias Mercancias usando el botón "Agregar Mercancia", la lista se mostrarán en la tabla de
              Mercancias.
            </p>
          </Col>
        </Row>

        <Row className="pt-3">
          {Guardian.allows('excel_cartaporte.access') && (
            <Col>
              <Button
                variant="secondary"
                onClick={this.handleOnShowUploadFile}
              >
                <FontAwesomeIcon icon={['fas', 'upload']} /> Usar excel
              </Button>
            </Col>
          )}

          <Col className="text-right">
            <Button
              variant="secondary"
              disabled={!isValid || (!isValidDetalleMercancia && isTouchedDetalleMercancia)}
              onClick={this.handleOnAdd}
            >
              Agregar Mercancia
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default CartaPorteMercancias;
